import { object, string, boolean } from 'yup';
import { YupValidation } from '@/modules/common/helpers/yup-validation';

function isValidITINOrSSN(value: string) {
  const digitsOnly = value.replace(/\D/g, '');
  return digitsOnly.length === 9;
}

function isValidNIF(value: string) {
  return value.length > 0;
}

const schema = object().shape({
  usPerson: object().shape({
    isUsPersonToggle: boolean(),
    itin: string().when('isUsPersonToggle', {
      is: true,
      then: string().test({
        name: 'itin-validation',
        test: function (value) {
          const { reasonOfAbsence } = this.parent;
          if (reasonOfAbsence) return true;
          if (!value)
            return this.createError({ message: 'ITIN ou SSN é obrigatório.' });
          if (!isValidITINOrSSN(value))
            return this.createError({
              message: 'SSN deve conter exatamente 9 dígitos.'
            });
          return true;
        }
      }),
      otherwise: string().notRequired()
    }),
    reasonOfAbsence: string().when('isUsPersonToggle', {
      is: true,
      then: string().test({
        name: 'reasonOfAbsence-validation',
        test: function (value) {
          const { itin } = this.parent;
          if (itin && isValidITINOrSSN(itin)) return true;
          if (!value)
            return this.createError({
              message: 'Justificativa é obrigatória.'
            });
          return true;
        }
      }),
      otherwise: string().notRequired()
    })
  }),
  taxResidence: object().shape({
    hasForeignTaxResidenceToggle: boolean(),
    country: string().when('hasForeignTaxResidenceToggle', {
      is: true,
      then: string().test({
        name: 'country-validation',
        test: function (value) {
          if (!value)
            return this.createError({
              message: 'País de residência fiscal é obrigatório.'
            });
          return true;
        }
      }),
      otherwise: string().notRequired()
    }),
    nif: string().when('hasForeignTaxResidenceToggle', {
      is: true,
      then: string().test({
        name: 'nif-validation',
        test: function (value) {
          const { reasonOfAbsence } = this.parent;
          if (reasonOfAbsence) return true;
          if (!value || !isValidNIF(value))
            return this.createError({ message: 'NIF é obrigatório.' });
          return true;
        }
      }),
      otherwise: string().notRequired()
    }),
    reasonOfAbsence: string().when('hasForeignTaxResidenceToggle', {
      is: true,
      then: string().test({
        name: 'taxResidence-reasonOfAbsence-validation',
        test: function (value) {
          const { nif } = this.parent;
          if (nif && isValidNIF(nif)) return true;
          if (!value)
            return this.createError({
              message: 'Justificativa é obrigatória.'
            });
          return true;
        }
      }),
      otherwise: string().notRequired()
    })
  })
});

export default new YupValidation(schema);
